import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PassengerListStandbyInt } from '@app/interfaces/micro/passengerListStandby.interface';
import { Passenger } from '@app/models/micro';

@Component({
    selector: 'am-passenger-list-priority-code',
    templateUrl: './am-passenger-list-priority-code.component.html',
    styleUrls: ['./am-passenger-list-priority-code.component.scss'],
    standalone: false
})

export class AmPassengerListPriorityCodeComponent implements OnInit, OnChanges {

  @Input() passengers: any; // Passenger[];
  @Input() type: 'upgrade' | 'standby' = 'upgrade';
  @Input() standByList: PassengerListStandbyInt | any = [];
  @Input() upgradeList: PassengerListStandbyInt | any = [];

  showTitleTwo: boolean = false;
  listSeatAssing: PassengerListStandbyInt | any = [];
  listSeatNotAssing: PassengerListStandbyInt | any = [];

  constructor() { }

  ngOnInit() {
    this.filterPassengers();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['type'] || changes['standByList'] || changes['upgradeList']) {
      this.filterPassengers();
    }
  }

  private filterPassengers() {
    if (this.type === 'standby') {
      if (this.standByList?.length > 0) {
        this.listSeatAssing = this.standByList.filter((p) => p.seat != null);
        this.listSeatNotAssing = this.standByList.filter((p) => p.seat == null);
      } else {
        this.listSeatAssing = [];
        this.listSeatNotAssing = [];
      }
    } else {
      if (this.upgradeList?.length > 0) {
        this.listSeatAssing = this.upgradeList.filter((p) => p.seat != null);
        this.listSeatNotAssing = this.upgradeList.filter((p) => p.seat == null);
      } else {
        this.listSeatAssing = [];
        this.listSeatNotAssing = [];
      }
    }

    this.showTitleTwo = this.listSeatNotAssing.length > 0;
  }

}
